module.exports = __webpack_public_path__ + "media/images/product_lines/travel/info-ae76bd7691c1b2db1057c31868c2f5ec.svg";